import React, { useEffect, useState } from 'react'
import Section from '../../SectionTitle/Section'
import SectionTitle from '../../SectionTitle/SectionTitle'
import styles from './styles.module.scss'
import PageTitle from '../../SectionTitle/PageTitle'
import GalleryCard from '../../GalleryCard/GalleryCard'
import getApi from '../../../http/getApi'
import Loading from '../../Loading/Loading'
import { Popup } from '../../Popup/Popup'
import { useLanguage } from '../../../context/LanguageContext'

export const Team = () => {
    const [index, setIndex] = useState(0)
    const { language } = useLanguage()
    const [load, setLoad] = useState(true)
    const [popupShow, setPopup] = useState(false)
    const [_id, set_id] = useState('')
    const [data, setData] = useState([]);
    const [params, setParams] = useState({
        page: 1,
        limit: 50
    });
    const [totalPages, setTotalPages] = useState(1);
    useEffect(() => {
        async function fetchData() {
            try {
                const queryString = new URLSearchParams(params).toString();
                const blogs = await getApi.getData(`/teams?${queryString}`);
                setData(blogs.data); // თუ გაქვს pagination სტრუქტურა, დაარეგულირე
                setTotalPages(blogs.totalPages); // თუ გიგზავნის საერთო გვერდებს
            } catch (err) {
                console.error('Error fetching blogs:', err);
            } finally {
                setLoad(false)
            }
        }

        fetchData();
    }, [params]);

    const leadership = data?.filter((item) => item.category === 'leadership')
    const calligraphers = data?.filter((item) => item.category === 'calligraphers')
    const board = data?.filter((item) => item.category === 'board')
    const honorary = data?.filter((item) => item.category === 'honorary')

    

    function closePopup() {
        document.body.style.overflow = 'unset'
        setPopup(false)
        set_id('')
    }

    const pageTitle = {
        ka: 'ჩვენი გუნდი',
        en: 'Our Team',
        ru: '組織体制',
    }
    const pageText = {
        ka: 'ტესტი',
        en: 'test',
        ru: 'テスト',
    }

    const title = {
        first: {
            ka: `დირექტორატი`,
            en: `Directorate`,
            ru: `執行部`
        },
        second: {
            ka: `ბორდი`,
            en: `Board`,
            ru: `理事`
        },
        threed: {
            ka: `კალიგრაფები`,
            en: `Calligraphers`,
            ru: `書道家`
        }
        ,
        fourth: {
            ka: `საპატიო წევრები`,
            en: `Honorary Member`,
            ru: `名誉会員`
        }
    }

    return (
        <>
            <Section>
                <PageTitle
                    title={pageTitle[language]}
                    text={''}
                />
                <SectionTitle title={title.first[language]} />
                {load && <Loading />}
                <div className='row d-flex justify-content-center'>
                    {leadership && leadership.filter(item => item._id === '690e5383d4d4aa1b9bd68acf').map((item, index) => {
                        return (
                            <div className='col-6 col-md-4 col-lg-3' key={item?._id}>
                                <GalleryCard
                                    cover={item?.cover}
                                    title={item?.title[language]}
                                    position={item?.position[language]}
                                    desc={item?.desc[language]}
                                    _id={item._id}
                                    setPopup={setPopup}
                                    set_id={set_id}
                                    itemIndex={index}
                                    setIndex={setIndex}
                                />
                            </div>
                        )
                    })}
                </div>
                <div className='row d-flex justify-content-center'>
                    {leadership && leadership.filter(item => item._id !== '690e5383d4d4aa1b9bd68acf').map((item, index) => {
                        return (
                            <div className='col-6 col-md-4 col-lg-3' key={item?._id}>
                                <GalleryCard
                                    cover={item?.cover}
                                    title={item?.title[language]}
                                    position={item?.position[language]}
                                    desc={item?.desc[language]}
                                    _id={item._id}
                                    setPopup={setPopup}
                                    set_id={set_id}
                                    itemIndex={index}
                                    setIndex={setIndex}
                                />
                            </div>
                        )
                    })}
                </div>
            </Section>
            <Section>
                <SectionTitle title={title.second[language]} />
                {load && <Loading />}
                <div className='row'>
                    {board && board.map((item, index) => {
                        return (
                            <div className='col-6 col-md-4 col-lg-3' key={item?._id}>
                                <GalleryCard
                                    cover={item?.cover}
                                    title={item?.title[language]}
                                    desc={item?.desc[language]}
                                    _id={item._id}
                                    setPopup={setPopup}
                                    set_id={set_id}
                                    itemIndex={index}
                                    setIndex={setIndex}
                                />
                            </div>
                        )
                    })}
                </div>
            </Section>
            <Section>
                <SectionTitle title={title.threed[language]} />
                {load && <Loading />}
                <div className='row'>
                    {calligraphers && calligraphers.map((item, index) => {
                        return (
                            <div className='col-6 col-md-4 col-lg-3' key={item?._id}>
                                <GalleryCard
                                    cover={item?.cover}
                                    title={item?.title[language]}
                                    desc={item?.desc[language]}
                                    _id={item._id}
                                    setPopup={setPopup}
                                    set_id={set_id}
                                    itemIndex={index}
                                    setIndex={setIndex}
                                />
                            </div>
                        )
                    })}
                </div>
            </Section>

            <Section>
                <SectionTitle title={title.fourth[language]} />
                {load && <Loading />}
                <div className='row'>
                    {honorary && honorary.map((item, index) => {
                        return (
                            <div className='col-6 col-md-4 col-lg-3' key={item?._id}>
                                <GalleryCard
                                    cover={item?.cover}
                                    title={item?.title[language]}
                                    desc={item?.desc[language]}
                                    _id={item._id}
                                    setPopup={setPopup}
                                    set_id={set_id}
                                    itemIndex={index}
                                    setIndex={setIndex}
                                />
                            </div>
                        )
                    })}
                </div>
            </Section>
            {popupShow && <Popup id={_id} name={'teams'} closePopup={closePopup} allGallery={data} setIndex={setIndex}/>}
        </>
    )
}
